import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import axiosInstance from '../../utils/axiosSetup.js';

const MyCalendar = () => {
    const [holidays, setHolidays] = useState([]);
    const localizer = momentLocalizer(moment)

    useEffect(() => {
        fetchHolidays();
    }, []);

    const fetchHolidays = async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/holidays`);
            setHolidays(response.data.data.holidays);
        } catch (error) {
            console.error("Error fetching holidays", error);
            setHolidays([]);
        }
    };

    // Prepare events for the calendar
    const events = holidays.map(holiday => ({
        id: holiday.id,
        title: holiday.name,
        start: new Date(holiday.date),
        end: new Date(holiday.date),
        allDay: true, // All holidays are considered as full-day events
    }));

    return (
        <>
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Calendar</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Calendar</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div>
                                    <Calendar
                                        localizer={localizer}
                                        events={events}
                                        startAccessor="start"
                                        endAccessor="end"
                                        style={{ height: 500 }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MyCalendar